import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectHasAllPermissions,
  selectHasAnyPermission,
  selectHasPermission,
} from 'app/reducers/context.selectors';
import { Observable } from 'rxjs';

/** Central facade for permission checks used by routes and feature components. */
@Injectable({ providedIn: 'root' })
export class PermissionService {
  constructor(private readonly store: Store) {}

  public hasPermission$(permissionCode: number): Observable<boolean> {
    return this.store.select(selectHasPermission(permissionCode));
  }

  public hasAnyPermission$(permissionCodes: readonly number[]): Observable<boolean> {
    return this.store.select(selectHasAnyPermission([...permissionCodes]));
  }

  public hasAllPermissions$(permissionCodes: readonly number[]): Observable<boolean> {
    return this.store.select(selectHasAllPermissions([...permissionCodes]));
  }
}
